import React from "react";
import Navbar2 from "../Components/Navbar2";
import CampCard from "../Components/CampCard";
import FeatureCard from "../Components/FeatureCard";

function ClinicsOpenGym() {
  return (
    <>
    <Navbar2 />
    <div className='container-fluid px-0 pb-4 pt-5'>
      <div className='h1 text-center'>
        CLINICS &amp; OPEN GYM
      </div>
      <div className="h4 ms-5 me-5 pb-3 fw-light text-center">
        Where athletes can sharpen their skills,
        train with experienced coaches, and enjoy 
        open play in a fun, flexible environment.
      </div>
      <div className="container-fluid pb-5">
        <div className="row g-0">
          <FeatureCard
            backgroundImage="./s3/feature_volleyball_tryouts.jpg"
            title="LOOKING FOR CLUB TRYOUTS?"
            linkUrl="/VolleyballTryouts"
            buttonText="CLICK HERE"
            fullWidth
          />
        </div>
      </div>
      <div className="row row-cols-1 row-cols-md-3 rows-col-lg-3 g-3">
        <div className='col'>
            <CampCard 
              backgroundImage="./s3/skills_camp.jpg"
              title={<>9U - 11U SERVING CLINICS <br/>2025-26</>}
              buttonText="REGISTER NOW"
              linkUrl="https://adssportscomplex.leagueapps.com/classes/4662452-9u---11u-serving-clinics---2025-26"
              location={<>Randolph High School<br/>1225 Perimeter Rd.<br/>Universal City, TX 78148</>}
              regularPrice={<>Regular Price $20.00</>}
              date_time={<>July 10 - Dec 18</>}
            />
          </div>
        <div className='col-12 col-md-4'>
            <CampCard 
              backgroundImage="./s3/middle_school_camp.jpg"
              title={<>9u to 12u All Skills Clinics</>}
              buttonText="VIEW CLINICS"
              linkUrl="https://adssportscomplex.leagueapps.com/classes/4662311-9u-to-12u-all-skills-clinics---2025-2026"
              date_time={<>Aug 4 - Aug 25 <br/>7:30PM - 8:30PM</>}
              regularPrice={<>Regular Price $20.00</>}
              location={<>Randolph High School<br/>1225 Perimeter Rd.<br/>Universal City, TX 78148</>}
            />
        </div>
        <div className='col-12 col-md-4'>
            <CampCard 
              backgroundImage="./s3/skills_camp.jpg"
              title={<>15u - 16u All Skills Clinic</>}
              buttonText="VIEW CLINICS"
              linkUrl="https://adssportscomplex.leagueapps.com/events/4709314-15u---16u-all-skills-clinics"
              date_time={<>Sep 14 - Oct 26</>}
              // regularPrice={<>Regular Price $20.00</>}
              location={<>Randolph High School<br/>1225 Perimeter Rd.<br/>Universal City, TX 78148</>}
            />
          </div>

        <div className='col'>
            <CampCard 
              backgroundImage="./s3/skills_camp.jpg"
              title={<>13U - 16U Combined Setting and Hitting 1.5 hr Clinic</>}
              buttonText="REGISTER NOW"
              linkUrl="https://adssportscomplex.leagueapps.com/events/4715214-13u---16u-combined-setting-and-hitting-1.5-hr-clinic"
              location={<>Randolph High School<br/>1225 Perimeter Rd.<br/>Universal City, TX 78148</>}
              regularPrice={<>Regular Price $20.00</>}
              date_time={<>Aug 12 - Oct 30</>}
            />
          </div>
          <div className='col-12 col-md-4'>
            <CampCard 
              backgroundImage="./s3/middle_school_camp.jpg"
              title={<>13U - 16U Combined Serving and Passing 1.5 hr Clinic</>}
              buttonText="VIEW CLINICS"
              linkUrl="https://adssportscomplex.leagueapps.com/events/4715210-13u---16u-combined-serving-and-passing-1.5-hr-clinic"
              date_time={<>Aug 12 - Oct 30</>}
              regularPrice={<>Regular Price $20.00</>}
              location={<>Randolph High School<br/>1225 Perimeter Rd.<br/>Universal City, TX 78148</>}
            />
          </div>
          <div className='col-12 col-md-4'>
            <CampCard 
              backgroundImage="./s3/skills_camp.jpg"
              title={<>13U - 16U Combined Passing and Setting 1.5 hr Clinic </>}
              buttonText="VIEW CLINICS"
              linkUrl="https://adssportscomplex.leagueapps.com/events/4715180-13u---16u-combined-passing-and-setting-1.5-hr-clinic"
              date_time={<>Aug 12 - Oct 30</>}
              regularPrice={<>Regular Price $20.00</>}
              location={<>Randolph High School<br/>1225 Perimeter Rd.<br/>Universal City, TX 78148</>}
            />
          </div>
          <div className='col-12 col-md-4'>
            <CampCard 
              backgroundImage="./s3/middle_school_camp.jpg"
              title={<>13U - 16U Combined Hitting and Blocking 1.5 hr Clinic </>}
              buttonText="VIEW CLINICS"
              linkUrl="https://adssportscomplex.leagueapps.com/events/4715218-13u---16u-combined-hitting-and-blocking-1.5-hr-clinic"
              date_time={<>Aug 12 - Oct 30</>}
              regularPrice={<>Regular Price $20.00</>}
              location={<>Randolph High School<br/>1225 Perimeter Rd.<br/>Universal City, TX 78148</>}
            />
          </div>
      </div>
    </div>
    </>
);
}

export default ClinicsOpenGym;
